import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Partners from "@/pages/Partners";
import PortafoglioPartner from "@/pages/PortafoglioPartner";
import Agencies from "@/pages/Agencies";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import AgencyActivities from "@/pages/AgencyActivities";
import ManagerActivities from "@/pages/ManagerActivities";
import Agenda from "@/pages/Agenda";
import PartnerProgram from "@/pages/PartnerProgram";
import PartnerDetail from "@/pages/PartnerDetail";
import AgencyDetail from "@/pages/AgencyDetail";
import Prospects from "@/pages/Prospects";
import ProspectDetail from "@/pages/ProspectDetail";
import StrumentoTecnico from "@/pages/StrumentoTecnico";
import ClientePortal from "@/pages/ClientePortal";
import CondivisoPage from "@/pages/CondivisoPage";
import { VestaLogin, VestaPassword, VestaForgot } from "@/pages/vesta/VestaAuth";
import VestaHome, { VestaSlot, VestaGuard, VestaParla } from "@/pages/vesta/VestaHome";
import VestaTariffario from "@/pages/vesta/VestaTariffario";
import { VestaVoiceHost } from "@/pages/vesta/VestaVoice";
import VestaBacheca from "@/pages/vesta/VestaBacheca";
import ProfiloPage from "@/pages/vesta/bacheca/ProfiloPage";
import { VestaConfiguratore } from "@/pages/vesta/VestaTools";
import Direzionale from "@/pages/Direzionale";
import ParametriProfilazione from "@/pages/ParametriProfilazione";
import ImportData from "@/pages/ImportData";
import PuntiVesta from "@/pages/PuntiVesta";
import ConfiguratoreFrame from "@/pages/ConfiguratoreFrame";
import ConversazioniVesta from "@/pages/ConversazioniVesta";
import PraticheConfiguratore from "@/pages/PraticheConfiguratore";
import ConsulenzeTecniche from "@/pages/ConsulenzeTecniche";
import TorriMonitoringPage from "@/pages/TorriMonitoringPage";
import EvMonitoringPage from "@/pages/EvMonitoringPage";
import TigoMonitoringPage from "@/pages/TigoMonitoringPage";
import Tools from "@/pages/Tools";
import ParametriDimensionamento from "@/pages/ParametriDimensionamento";
import CatalogoVesta from "@/pages/CatalogoVesta";
import EditCatalogo from "@/pages/EditCatalogo";
import AzioniMarketing from "@/pages/AzioniMarketing";
import Orders from "@/pages/Orders";
import Commesse from "@/pages/Commesse";
import Preventivi from "@/pages/Preventivi";
import BackOffice from "@/pages/BackOffice";
import Affidamenti from "@/pages/Affidamenti";
import OrdinatiScoperti from "@/pages/OrdinatiScoperti";
import Approvvigionamenti from "@/pages/Approvvigionamenti";
import StimaMagazzino from "@/pages/StimaMagazzino";
import Listino from "@/pages/Listino";
import Preventivatore from "@/pages/Preventivatore";
import ConfigTrasporto from "@/pages/ConfigTrasporto";
import CondizioniContratto from "@/pages/CondizioniContratto";
import Anagrafiche from "@/pages/Anagrafiche";
import ObiettiviAgenzie from "@/pages/ObiettiviAgenzie";
import Operativita from "@/pages/Operativita";
import Backups from "@/pages/Backups";
import NoteQualitySettings from "@/pages/NoteQualitySettings";
import MicheleTorri from "@/pages/MicheleTorri";
import MailAutomatiche from "@/pages/MailAutomatiche";
import Newsletter from "@/pages/Newsletter";
import VestaDemo from "@/pages/vesta/VestaDemo";
import ComunicazioniVesta from "@/pages/ComunicazioniVesta";
import Rubrica from "@/pages/Rubrica";
import Subscribe from "@/pages/Subscribe";
import ChangePassword from "@/pages/ChangePassword";
import { Toaster } from "@/components/ui/sonner";
import { VestaSplash } from "@/pages/vesta/VestaSplash";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

const RoleHome = () => {
  const { user } = useAuth();
  if (user?.role === "technical") return <Navigate to="/tools" replace />;
  if (user?.role === "back_office") return <Navigate to="/preventivi" replace />;
  if (user?.role === "head_of_partner") return <Navigate to="/beyond/punti-vesta" replace />;
  if (user?.role === "commercial_manager") return <Navigate to="/direzionale" replace />;
  return <Dashboard />;
};

const RequirePage = ({ page, children }) => {
  const { user } = useAuth();
  const ok = user?.role === "admin" || (user?.extra_pages || []).includes(page);
  if (!ok) return <Navigate to="/" replace />;
  return children;
};

const RequireRole = ({ roles, children }) => {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <VestaSplash />
        <VestaVoiceHost />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/vesta-demo" element={<VestaDemo />} />
          <Route path="/vesta" element={<VestaLogin />} />
          <Route path="/vesta/password" element={<VestaPassword />} />
          <Route path="/vesta/recupera" element={<VestaForgot />} />
          <Route path="/vesta/home" element={<VestaGuard><VestaHome /></VestaGuard>} />
          <Route path="/vesta/parla" element={<VestaGuard><VestaParla /></VestaGuard>} />
          <Route path="/vesta/bacheca" element={<VestaGuard><VestaBacheca /></VestaGuard>} />
          <Route path="/vesta/bacheca/profilo/:uid" element={<VestaGuard><ProfiloPage /></VestaGuard>} />
          <Route path="/vesta/configuratore" element={<VestaGuard><VestaConfiguratore /></VestaGuard>} />
          <Route path="/vesta/tariffario" element={<VestaGuard><VestaTariffario /></VestaGuard>} />
          <Route path="/vesta/slot/:key" element={<VestaGuard><VestaSlot /></VestaGuard>} />
          <Route path="/strumenti/:token" element={<StrumentoTecnico />} />
          <Route path="/cliente/:token" element={<ClientePortal />} />
          <Route path="/condiviso/:token" element={<CondivisoPage />} />
          <Route path="/iscriviti" element={<Subscribe />} />
          <Route path="/" element={<Shell><RoleHome /></Shell>} />
          <Route path="/dashboard-direzione" element={<Shell><Dashboard /></Shell>} />
          <Route path="/partners" element={<Shell><Partners /></Shell>} />
          <Route path="/partners/:id" element={<Shell><PartnerDetail /></Shell>} />
          <Route path="/agencies" element={<Shell><Agencies /></Shell>} />
          <Route path="/agencies/:id" element={<Shell><AgencyDetail /></Shell>} />
          <Route path="/reports" element={<Shell><Reports /></Shell>} />
          <Route path="/obiettivi-agenzie" element={<Shell><ObiettiviAgenzie /></Shell>} />
          <Route path="/operativita" element={<Shell><Operativita /></Shell>} />
          <Route path="/users" element={<Shell><RequireRole roles={["admin"]}><Users /></RequireRole></Shell>} />
          <Route path="/backup" element={<Shell><RequireRole roles={["admin"]}><Backups /></RequireRole></Shell>} />
          <Route path="/activities" element={<Shell><AgencyActivities /></Shell>} />
          <Route path="/attivita-agenzie" element={<Shell><AgencyActivities /></Shell>} />
          <Route path="/attivita-responsabile" element={<Shell><ManagerActivities /></Shell>} />
          <Route path="/agenda" element={<Shell><Agenda /></Shell>} />
          <Route path="/programma" element={<Shell><PartnerProgram /></Shell>} />
          <Route path="/prospects" element={<Shell><Prospects /></Shell>} />
          <Route path="/clienti/mappa" element={<Shell><Partners mode="map" /></Shell>} />
          <Route path="/clienti/portafoglio" element={<Shell><Partners mode="table" /></Shell>} />
          <Route path="/beyond/portafoglio-partner" element={<Shell><PortafoglioPartner /></Shell>} />
          <Route path="/prospect/mappa" element={<Shell><Prospects mode="map" /></Shell>} />
          <Route path="/prospect/funnel" element={<Shell><RequireRole roles={["admin", "commercial_manager", "agency", "head_of_partner"]}><Prospects mode="funnel" /></RequireRole></Shell>} />
          <Route path="/prospect/:id" element={<Shell><ProspectDetail /></Shell>} />
          <Route path="/direzionale" element={<Shell><Direzionale /></Shell>} />
          <Route path="/parametri-profilazione" element={<Shell><RequireRole roles={["admin"]}><ParametriProfilazione /></RequireRole></Shell>} />
          <Route path="/import-dati" element={<Shell><RequireRole roles={["admin"]}><ImportData /></RequireRole></Shell>} />
          <Route path="/beyond/punti-vesta" element={<Shell><PuntiVesta /></Shell>} />
          <Route path="/configuratore/:id" element={<Shell><ConfiguratoreFrame /></Shell>} />
          <Route path="/pratiche-configuratore" element={<Shell><PraticheConfiguratore /></Shell>} />
          <Route path="/conversazioni-vesta" element={<Shell><ConversazioniVesta /></Shell>} />
          <Route path="/consulenze-tecniche" element={<Shell><ConsulenzeTecniche /></Shell>} />
          <Route path="/torri-monitoring" element={<Shell><TorriMonitoringPage /></Shell>} />
          <Route path="/ev-monitoring" element={<Shell><EvMonitoringPage /></Shell>} />
          <Route path="/tigo-monitoring" element={<Shell><TigoMonitoringPage /></Shell>} />
          <Route path="/tools" element={<Shell><Tools /></Shell>} />
          <Route path="/parametri-dimensionamento" element={<Shell><ParametriDimensionamento /></Shell>} />
          <Route path="/beyond/catalogo-vesta" element={<Shell><CatalogoVesta /></Shell>} />
          <Route path="/beyond/edit-catalogo" element={<Shell><EditCatalogo /></Shell>} />
          <Route path="/beyond/azioni-marketing" element={<Shell><AzioniMarketing /></Shell>} />
          <Route path="/ordini" element={<Shell><Orders /></Shell>} />
          <Route path="/commesse" element={<Shell><Commesse /></Shell>} />
          <Route path="/preventivi" element={<Shell><Preventivi /></Shell>} />
          <Route path="/backoffice" element={<Shell><BackOffice /></Shell>} />
          <Route path="/affidamenti" element={<Shell><Affidamenti /></Shell>} />
          <Route path="/ordinati-scoperti" element={<Shell><OrdinatiScoperti /></Shell>} />
          <Route path="/approvvigionamenti" element={<Shell><Approvvigionamenti /></Shell>} />
          <Route path="/stima-magazzino" element={<Shell><StimaMagazzino /></Shell>} />
          <Route path="/listino" element={<Shell><Listino /></Shell>} />
          <Route path="/preventivatore" element={<Shell><Preventivatore /></Shell>} />
          <Route path="/config-trasporto" element={<Shell><RequireRole roles={["admin"]}><ConfigTrasporto /></RequireRole></Shell>} />
          <Route path="/condizioni-contratto" element={<Shell><RequireRole roles={["admin"]}><CondizioniContratto /></RequireRole></Shell>} />
          <Route path="/anagrafiche" element={<Shell><Anagrafiche /></Shell>} />
          <Route path="/impostazioni-note" element={<Shell><RequireRole roles={["admin"]}><NoteQualitySettings /></RequireRole></Shell>} />
          <Route path="/michele-torri" element={<Shell><RequireRole roles={["admin"]}><MicheleTorri /></RequireRole></Shell>} />
          <Route path="/mail-automatiche" element={<Shell><RequireRole roles={["admin"]}><MailAutomatiche /></RequireRole></Shell>} />
          <Route path="/comunicazioni-vesta" element={<Shell><RequireRole roles={["admin", "head_of_partner"]}><ComunicazioniVesta /></RequireRole></Shell>} />
          <Route path="/newsletter" element={<Shell><RequireRole roles={["admin", "head_of_partner"]}><Newsletter /></RequireRole></Shell>} />
          <Route path="/rubrica" element={<Shell><RequireRole roles={["admin", "head_of_partner"]}><Rubrica /></RequireRole></Shell>} />
          <Route path="/cambia-password" element={<Shell><ChangePassword /></Shell>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
